document.addEventListener("DOMContentLoaded", function(){

const input = document.querySelector('input[name="q"]');
if(!input) return;

let dropdown = document.createElement("ul");
dropdown.className = "box-results";
const wrapper = input.closest(".search-wrapper");
wrapper.appendChild(dropdown);

input.addEventListener("keyup", function(){

let term = input.value.trim();

if(term.length < 3){
dropdown.innerHTML="";
return;
}

fetch("/search/suggest.json?q=" + term + "&resources[type]=product")

.then(res => res.json())
.then(data => {

let products = data.resources.results.products;

/* EXACT PART NUMBER FIRST */

products.sort(function(a,b){

let termUpper = term.toUpperCase();

let aExact = a.title.toUpperCase().includes(termUpper);
let bExact = b.title.toUpperCase().includes(termUpper);

if(aExact && !bExact) return -1;
if(!aExact && bExact) return 1;

return 0;

});

dropdown.innerHTML = "";

products.forEach(function(product){

let li = document.createElement("li");

li.innerHTML =
'<a href="'+product.url+'">'+
'<span class="thumbnail"><img src="'+product.featured_image.url+'"></span>'+
'<span class="title_name">'+product.title+'</span>'+
'</a>';

dropdown.appendChild(li);

});

});

});

});